<template>
  <div class="relative h-screen">
    <div class="h-full inset-0 absolute">
      <base-video

        autoplay
        :controls="false"
        fit="cover"
        loop
        src="https://assets.vans.com/video/upload/v1738710848/404-video-optimized-red"
      />
    </div>
    <div v-style:p="{ sm: '3.5rem 1rem 0 1rem' }" class="c-white relative container lg:pt-16">
      <cms-section v-if="eSpots?.['over-image']" class="mb-8" :section="eSpots['over-image']" />
      <h1 class="display-1 pb-6 uppercase">
        {{ $t.maintenance.ERR404.title }}
      </h1>
      <div class="mt-4 ws-pre-wrap space-y-6 lg:text-md lg:mt-6">
        <p>
          {{ $t.maintenance.ERR404.message }}
        </p>
        <p class="fw-bold">
          {{ $t.maintenance.ERR404.nextStepsHeader }}
        </p>
        <span>
          {{ $t.maintenance.ERR404.nextStepsDetails }}
        </span>
      </div>
      <vf-button class="mt-8 b-white <md:w-full" variant="transparent" @click="clearError({ redirect: '/' })">
        {{ $t.maintenance.ERR4xx.cta }}
      </vf-button>
      <cms-section v-if="eSpots?.['lazy-main']" class="mb-16 mt-8 lg:mb-20" :section="eSpots['lazy-main']" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()
const eSpots = $feature.enable404Espots && (await useCms().getSections.error()).data.value?.content.sectionsMap
useSeoMeta({ title: $t.error, robots: $feature.enableNoindexOnErrorPages ? 'noindex, nofollow' : '' })
</script>
